import React from 'react';

type WidgetTabsTabProps = {
    children: React.ReactNode;
};

const WidgetTabsTab: React.FC<WidgetTabsTabProps> = ({ children }) => {
    return <>{ children }</>;
};

export default WidgetTabsTab;
